var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.7784L19.1367 27.2217L25.5 19.4451",
    stroke: "#EB5757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1668 9.16667C27.1668 8.28261 26.8156 7.43477 26.1905 6.80964C25.5654 6.18452 24.7176 5.83333 23.8335 5.83333C23.8335 4.94928 23.4823 4.10143 22.8572 3.47631C22.2321 2.85119 21.3842 2.5 20.5002 2.5C19.6161 2.5 18.7683 2.85119 18.1431 3.47631C17.518 4.10143 17.1668 4.94928 17.1668 5.83333C16.2828 5.83333 15.4349 6.18452 14.8098 6.80964C14.1847 7.43477 13.8335 8.28261 13.8335 9.16667V10.8333H27.1668V9.16667Z",
    stroke: "#EB5757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6667 7.5H31.3333C31.7754 7.5 32.1993 7.6756 32.5118 7.98816C32.8244 8.30072 33 8.72464 33 9.16667V34.1667C33 34.6087 32.8244 35.0326 32.5118 35.3452C32.1993 35.6577 31.7754 35.8333 31.3333 35.8333H9.66667C9.22464 35.8333 8.80072 35.6577 8.48816 35.3452C8.1756 35.0326 8 34.6087 8 34.1667V9.16667C8 8.72464 8.1756 8.30072 8.48816 7.98816C8.80072 7.6756 9.22464 7.5 9.66667 7.5H11.3333",
    stroke: "#EB5757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipRed);
export default __webpack_public_path__ + "static/media/clipRed.9dd0d79dcd0417c9ba8e2bba6b42afd1.svg";
export { ForwardRef as ReactComponent };